var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-scroll-view",
    { attrs: { tag: "w-container" } },
    [
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c(
                "w-card",
                [
                  _c("w-card-title", [_vm._v("Nieuw ticket aanmaken")]),
                  _c(
                    "w-card-content",
                    [
                      _c(
                        "w-row",
                        [
                          _c(
                            "w-col",
                            { attrs: { md: "6", xs: "12" } },
                            [
                              _c("app-client-search", {
                                attrs: {
                                  fancy: "",
                                  label: "Klant zoeken",
                                  required: "",
                                },
                                model: {
                                  value: _vm.client,
                                  callback: function ($$v) {
                                    _vm.client = $$v
                                  },
                                  expression: "client",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { md: "6", xs: "12" } },
                            [
                              _c("app-dossier-select", {
                                attrs: {
                                  "company-id": _vm.client?.companyId,
                                  dossiers: _vm.client?.company.dossiers,
                                  disabled: _vm.ticketData.dossierId <= 0,
                                  fancy: "",
                                  label: "Dossier",
                                },
                                model: {
                                  value: _vm.ticketData.dossierId,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ticketData, "dossierId", $$v)
                                  },
                                  expression: "ticketData.dossierId",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { md: "6", xs: "12" } },
                            [
                              _c("w-input", {
                                attrs: {
                                  fancy: "",
                                  label: "Onderwerp",
                                  required: "",
                                },
                                model: {
                                  value: _vm.ticketData.subject,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ticketData, "subject", $$v)
                                  },
                                  expression: "ticketData.subject",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { md: "6", xs: "12" } },
                            [
                              _c("app-department-select", {
                                attrs: { fancy: "", label: "Afdeling" },
                                model: {
                                  value: _vm.ticketData.departmentId,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.ticketData,
                                      "departmentId",
                                      $$v
                                    )
                                  },
                                  expression: "ticketData.departmentId",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { md: "6", xs: "12" } },
                            [
                              _c("app-admin-select", {
                                attrs: { fancy: "", label: "Attentie vragen" },
                                model: {
                                  value: _vm.attentions,
                                  callback: function ($$v) {
                                    _vm.attentions = $$v
                                  },
                                  expression: "attentions",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { md: "6", xs: "12" } },
                            [
                              _c("app-admin-select", {
                                attrs: { fancy: "", label: "Toegewezen aan" },
                                model: {
                                  value: _vm.admins,
                                  callback: function ($$v) {
                                    _vm.admins = $$v
                                  },
                                  expression: "admins",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            {
                              style: { display: "flex", flexDirection: "row" },
                              attrs: { md: "6", xs: "12" },
                            },
                            [
                              _vm.sheduleTicket
                                ? _c("w-date-picker", {
                                    style: {
                                      flexGrow: "1",
                                      marginRight: "10px",
                                    },
                                    attrs: {
                                      fancy: "",
                                      label: "Datum planning",
                                    },
                                    model: {
                                      value: _vm.date,
                                      callback: function ($$v) {
                                        _vm.date = $$v
                                      },
                                      expression: "date",
                                    },
                                  })
                                : _vm._e(),
                              _vm.sheduleTicket
                                ? _c("w-input-time", {
                                    style: { minWidth: "180px" },
                                    attrs: {
                                      fancy: "",
                                      label: "Tijdstip planning",
                                      step: "900",
                                    },
                                    model: {
                                      value: _vm.time,
                                      callback: function ($$v) {
                                        _vm.time = $$v
                                      },
                                      expression: "time",
                                    },
                                  })
                                : _vm._e(),
                              _vm.sheduleTicket
                                ? _c(
                                    "w-link",
                                    {
                                      staticClass: "mt",
                                      on: {
                                        click: function ($event) {
                                          _vm.sheduleTicket = false
                                        },
                                      },
                                    },
                                    [
                                      _c("w-fa", {
                                        style: { marginLeft: "10px" },
                                        attrs: { icon: "times" },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            {
                              style: { display: "flex", flexDirection: "row" },
                              attrs: { md: "6", xs: "12" },
                            },
                            [
                              _c("w-spacer"),
                              _c(
                                "w-link",
                                {
                                  staticClass: "mt",
                                  on: {
                                    click: function ($event) {
                                      _vm.sheduleTicket = true
                                    },
                                  },
                                },
                                [
                                  _c("w-fa", {
                                    style: { marginRight: "5px" },
                                    attrs: { icon: "calendar" },
                                  }),
                                  _vm._v(" Ticket plannen "),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { md: "12", xs: "12" } },
                            [
                              _c("w-checkbox", {
                                attrs: { label: "Intern ticket" },
                                model: {
                                  value: _vm.ticketData.internal,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ticketData, "internal", $$v)
                                  },
                                  expression: "ticketData.internal",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { xs: "12" } },
                            [
                              _c("w-textarea-autogrow", {
                                attrs: {
                                  "auto-grow": "",
                                  fancy: "",
                                  label: "Boodschap",
                                  required: "",
                                },
                                model: {
                                  value: _vm.ticketData.message,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ticketData, "message", $$v)
                                  },
                                  expression: "ticketData.message",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-card-actions",
                    [
                      _c("w-spacer"),
                      _c(
                        "w-button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.submit()
                            },
                          },
                        },
                        [_vm._v(" Ticket aanmaken ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }